import React from "react";

import Context from "../../context";

import { useTranslation } from "react-i18next";
import { IAcademicYear } from "../../types/academicYear.interface";

import "./index.scss";

// ? Panel-wide academic year (سال تحصیلی) selector. Mounted once in components/Layout so it sits above every screen;
// ? the screens themselves only read the selected year out of Context.AcademicYear.
const AcademicYearSelect: React.FC = () => {

  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const { years, selectedYear, setSelectedYear, isLoading } = React.useContext(Context.AcademicYear);

  function onSelect(academicYear: IAcademicYear): void {
    setIsOpen(false);
    setSelectedYear!(academicYear);
  }

  // ? Nothing to choose between: with a single year (or none seeded yet) the control would only be noise.
  if (!isLoading && (years ?? []).length < 2) return null;

  return (
    <div id="academic-year-select">
      <section id="academic-year-select-container">
        <div className="tooltip-hover">
          <span>{t("academic_year")}</span>
          <div className="after-arrow"></div>
        </div>
        <div className="icon" onClick={() => setIsOpen((previous: boolean) => !previous)}>
          <i className="fa-regular fa-calendar"></i>
          <span className="label">{isLoading ? "..." : selectedYear?.key ?? t("academic_year")}</span>
          <i className="fa-regular fa-caret-down"></i>
        </div>
      </section>
      <ul className={`dropdown ${isOpen ? "open" : "close"}`}>
        {(years ?? []).map((academicYear: IAcademicYear) => (
          <li
            key={academicYear._id}
            className={academicYear._id === selectedYear?._id ? "selected" : ""}
            onClick={() => onSelect(academicYear)}
          >
            {academicYear.name ?? academicYear.key}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AcademicYearSelect;
